import request from '@/api/request'

export default {
  async getAttributes (categoryId) {
    return (await request.get(`module/action/marketplace/colombo/category/attributes/${categoryId}`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/colombo/index.js